import { useState, useEffect } from 'react';

export const useElementDimensions = (id: string) => {
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const container = document.getElementById(id);
    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const { target } = entry;
        if (target instanceof HTMLElement) {
          const nextDimensions = {
            width: target.offsetWidth,
            height: target.offsetHeight,
          };
          setDimensions((previousDimensions) =>
            previousDimensions.width === nextDimensions.width &&
            previousDimensions.height === nextDimensions.height
              ? previousDimensions
              : nextDimensions
          );
        }
      });
    });

    if (container) {
      resizeObserver.observe(container);
    }

    return () => {
      if (container) {
        resizeObserver.unobserve(container);
      }
    };
  }, [id]);

  return dimensions;
};
